// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"a51f8049","169":"4a546924","269":"bcd7353a","402":"6cec4d9a","429":"3a98bc90","482":"aebdc0b3","507":"8817fdea","824":"e19e51f3"}[chunkId] + ".chunk.js";
};